import { ENVIRONMENT_KEYS } from './environment';
import {
  APP_IS_READY,
  AUTH_FINISH_ONBOARDING,
  AUTH_LOGIN,
  AUTH_LOGOUT,
  FIRST_TIME,
} from '../store/actions';

export const EVENTS = {
  APPLICATION: {
    FIRST_INIT: '[Application] First Init',
    OPEN: '[Application] Open',
    PAGE_VIEW: 'Page View',
  },
  UPDATE_MANAGER: {
    UPDATE: '[Update Manager] Update',
  },
  CONTENT: {
    OPEN: '[Content] Open',
    UPLOAD: '[Content] Upload',
    UPDATE: '[Content] Update',
  },
  KNOWLEDGE_ITEMS: {
    OPEN: '[Knowledge] Open',
    CLOSE: '[Knowledge] Close',
    OPEN_INFORMATION: '[Knowledge] Information - open',
    CLOSE_INFORMATION: '[Knowledge] Information - close',
    FILTER_BY_ALL: '[Knowledge] Filter by all',
    FILTER_BY_DOCUMENTS: '[Knowledge] Filter by documents',
    FILTER_BY_MEDIA: '[Knowledge] Filter by media',
    FILTER_BY_CONTACTS: '[Knowledge] Filter by contacts',
    FILTER_BY_COMPENDIUM: '[Knowledge] Filter by compendium',
    FILTER_BY_CHECKLIST: '[Knowledge] Filter by checklist',
    SEARCH_CLICK: '[Knowledge] Search - click',
    SEARCH_ON_BLUR: '[Knowledge] Search - on blur',
    EDIT_ITEM: '[Knowledge] Edit item',
    CLOSE_EDIT_MODE: '[Knowledge] Close edit mode',
    CREATE_KNOWLEDGE_ITEM: '[Knowledge] Create knowledge',
    UPDATE_KNOWLEDGE_ITEM: '[Knowledge] Update knowledge',
    TOC_SCROLL: '[Knowledge] TOC scroll',
    TOGGLE_SMART_FORMAT: '[Knowledge] Toggle smart format',
    CREATE_NEW_ITEM_BUTTON: '[Knowledge] Create new item button',
    UPLOAD_FILE_IMPRESSION: '[Knowledge] Upload file impression',
    UPLOAD_FILE_START: '[Knowledge] Upload file start',
    UPLOAD_FILE_DONE: '[Knowledge] Upload file done',
    OPEN_TOC: '[Knowledge] Open TOC',
    CLOSE_TOC: '[Knowledge] Close TOC',
    DOWNLOAD_FILE: '[Knowledge] Download file',
    DOWNLOAD_FILE_IMPRESSION: '[Knowledge] Download file impression',
    OPEN_IN_NEW_TAB: '[knowledge] Open in new tab',
    DUPLICATION_DETECTED: '[Knowledge] Duplication detected - impression',
    DUPLICATION_DETECTED_CREATE_LINK: '[Knowledge] Duplication detected - create link',
    DUPLICATION_DETECTED_DISMISS: '[Knowledge] Duplication detected - dismiss',
    FAILED_TO_LOAD: '[Knowledge] Failed to load knowledge',
    MOVE: '[Knowledge] Move item',
  },
  SMART_FORMAT_CONVERSION: {
    TOGGLE_STATE: '[SmartFormat] Toggle state',
    START: '[SmartFormat] Process start',
    DONE: '[SmartFormat] Process done',
    FAILED: '[SmartFormat] Process failed',
  },
  SMART_FORMAT_CONVERSION_TIME: {
    LATER: 'later',
    IMMEDIATE: 'immediate',
  },
  ONBOARDING: {
    FINISH: '[Onboarding] finish',
    CLICK_ON_NEXT: '[Onboarding] next',
  },

  AUTH: {
    LOGIN: '[Auth] Login',
    LOGOUT: '[Auth] Logout',
    MAGIC_LINK_TRIGGERED: '[Auth] Magic link triggered',
    LOGIN_BUBBLE_CLICKED: '[Auth] Login bubble clicked',
    LOGIN_BUBBLE_LOGIN_FLOW_OPENED: '[Auth] Login bubble login flow opened',
    LOGIN_BUBBLE_LOGIN_FLOW_CLOSED: '[Auth] Login bubble login flow closed',
    LOGIN_BUBBLE_LOGIN_SUCCESS: '[Auth] Login bubble login success',
    LOGIN_BUBBLE_LOGIN_FAILED: '[Auth] Login bubble login failed',
    LOGIN_FAILED: '[Auth] Login failed',
  },
  BIOMETRICS: {
    SUGGEST_ENROLLMENT_SHOWN: '[Biometrics] Suggest Enrollment',
    SUGGEST_ENROLLMENT_RESPONSE: '[Biometrics] Suggest Enrollment response',
    TOGGLE: '[Biometrics] Toggle',
  },
  WELCOME: {},
  APPLICATION_SCREEN: {
    HEADER_CLICK: '[Header] Click on header',
  },
  NOTIFICATION_MODAL: {
    CONFIRM: '[Notification] Confirm',
    CONFIRM_AND_APPROVED: '[Notification] Confirm and Approved',
    CONFIRM_AND_DENIED: '[Notification] Confirm and Denied',
    LATER: '[Notification] Later',
  },
  NOTIFICATIONS: {
    OPEN_NOTIFICATION: '[Notification] Open from notification',
    OPEN_KNOWLEDGE_ITEM_FROM_NOTIFICATION: '[Notification] Open knowledge item',
    CLOSE_KNOWLEDGE_ITEM_FROM_NOTIFICATION: '[Notification] Close knowledge item',
  },
  LAB_ITEMS: {
    OPEN: '[Lab] Open',
    OPEN_INFORMATION: '[Lab] Information - open',
    CLOSE_INFORMATION: '[Lab] Information - close',
  },
  CHECKLISTS: {
    OPEN: '[Checklist] Open',
    SIGN_AND_SEND: '[Checklist] Sign and Send',
    CREATE_REPORT: '[Checklist] Create Report',
    MOVE: '[Checklist] Move',
  },
  SEARCH: {
    RESULTS_LISTED: '[Search] Results listed',
    RESULT_CLICKED: '[Search] Result clicked',
    SHOW_MORE: '[Search] Show more',
    FOCUS: '[Search] Focus on search bar',
    RESULTS_PAGE_VIEW: '[Search] Results page view',
    RESULTS_IMPRESSION: '[Search] Results impression',
  },

  LANGUAGE_SELECTOR: {
    OPEN: '[Lang Selector] Open',
    SELECT_LANG: '[Lang Selector] Select lang',
  },
  EDITOR: {
    OPEN: '[Editor] Open',
  },
  USER_PROFILE: {
    OPEN: '[Profile] Open',
    COMPLETE: '[Profile] Complete profile',
    UPDATE: '[Profile] Update',
    SNOOZE: '[Profile] Snooze',
    EDIT_PHOTO_CLICK: '[Profile] Edit photo click',
    UPLOAD_PHOTO_CLICK: '[Profile] Upload photo click',
    UPLOAD_PHOTO: '[Profile] Upload photo',
    REMOVE_PHOTO_CLICK: '[Profile] Remove photo click',
    REMOVE_PHOTO_SUBMIT: '[Profile] Remove photo submit',
    BULK_UPLOAD_PHOTOS: '[Profile] Bulk upload photos',
  },
  DEEP_LINK: {
    OPEN: '[Deep Link] Open',
  },
  FAVORITES: {
    ADD: '[Favorites] Add',
    REMOVE: '[Favorites] Remove',
  },
  SHARE: {
    COPY_LINK: '[Share] Copy link',
  },
  CONTACT: {
    CALL: '[Contact] Call',
    SMS: '[Contact] SMS',
    PAGER: '[Contact] Pager',
    CISCO: '[Contact] Cisco',
    EMAIL: '[Contact] Email',
    OPEN_DETAILS: '[Contact] Open details',
    EDIT: '[Contact] Edit',
    SAVE: '[Contact] Save',
    PROFILE_PHOTO_OPEN: '[Contacts] profile photo open',
  },
  CONTACT_ADD: {
    ADD_CLICK: '[Add Contact] click',
    ADD_SAVE: '[Add Contact] save',
  },
  USER_ADD: {
    ADD_CLICK: '[Add User] click',
    ADD_SAVE: '[Add User] save ',
  },
  USER_PREFERENCES: {
    ADD_RESOURCE: '[User] Add resource',
    RESOURCE_OPEN: '[User] Resource open',
    DELETE_RESOURCE: '[User] Delete resource',
  },
  USER_INVITE: {
    CLICK_INVITE: '[User Invite] click',
    SAVE_INVITE: '[User Invite] save',
  },
  SUGGEST_CONTENT: {
    START: '[Suggest Content] Start Suggesting',
    SELECT_SOURCE: '[Suggest Content] Select Source',
    SUBMIT: '[Suggest Content] Submit',
  },
  SUGGEST_KEYWORDS: {
    ADD: '[Suggest Keywords] Add keywords',
  },
  ROTATIONS: {
    OPEN_LINK: '[Rotations] Open link',
    OPEN: '[Rotations] Open',
    SEARCH: '[Rotations] Search',
    SIDEBAR_TAB_SELECTED: '[Rotations] Sidebar Tab selected',
    TAB_SELECTED: '[Rotations] Tab selected',
    ADD_RESOURCES_CLICK: '[Rotations] Add resources click',
    ADD_RESOURCE: '[Rotations] Add resource',
    RESOURCE_OPEN: '[Rotations] Resource open',
    DELETE_RESOURCE: '[Rotations] Delete resource',
    EDIT_ROTATION_DETAILS_CLICK: '[Rotations] Edit rotation details click',
    ROTATION_DETAILS_UPDATED: '[Rotations] Rotation details updated',
    ADD_TEAM_MEMBER: '[Rotations] Add team member',
    REMOVE_TEAM_MEMBER: '[Rotations] Remove team member',
    TEAM_MEMBER_CLICKED: '[Rotations] Team member clicked',
    WELCOME_LETTER_EDIT: '[Rotations] Edit welcome letter',
    WELCOME_LETTER_PREVIEW: '[Rotations] Preview welcome letter',
    WELCOME_LETTER_SAVE: '[Rotations] Save welcome letter',
  },
  AI_CHAT: {
    OPEN: '[AI Chat] Open',
    CLOSE: '[AI Chat] Close',
    MESSAGE: '[AI Chat] Message',
    ERROR: '[AI Chat] Error',
    EDIT_MESSAGE: '[AI Chat] Edit message',
    CLEAR_CHAT: '[AI Chat] Clear chat',
    COPY_TO_CLIPBOARD: '[AI Chat] Copy to clipboard',
    OPEN_RESOURCES: '[AI Chat] Open resources',
    OPEN_REFERENCES: '[AI Chat] Open references',
    TOGGLE_REFERENCE: '[AI Chat] Toggle reference',
    RESOURCE_OPEN: '[AI Chat] resource open',
    // v1 (ask-panda-chat) granular feedback events. Deprecated — panda v2 emits
    // the unified FEEDBACK_V2 event below instead.
    FEEDBACK: {
      GOOD: '[AI Chat] Good feedback',
      BAD: '[AI Chat] Bad feedback',
      CANCELED: '[AI Chat] Cancel feedback',
    },
    // Panda v2: single feedback event; `type` = positive | negative | canceled.
    FEEDBACK_V2: '[AI Chat] feedback',
    SUBMIT_FEEDBACK: '[AI Chat] Submit feedback',
    BAD_FEEDBACK_OPTION: '[AI Chat] Chose bad feedback option',
    UNSELECT_FEEDBACK_OPTION: '[AI Chat] Unselect feedback option',
  },
  KNOWLEDGE_COMMENTS: {
    COMMENT_SENT: '[Knowledge Comments] Comment sent',
    REPLY_CLICKED: '[Knowledge Comments] Reply clicked',
    DELETE_CLICKED: '[Knowledge Comments] Delete clicked',
    COMMENTS_LINK_CLICKED: '[Knowledge Comments] Comments link clicked',
  },
  CATEGORIES: {
    ADD: '[Categories] Add new category',
    REMOVE: '[Categories] Remove category',
    EDIT: '[Categories] Edit category',
    UPDATE: '[Categories] Update category',
    MOVE: '[Categories] Move category',
    COPY: '[Categories] Copy category',
  },
  KNOWLEDGE_HUB: {
    OPEN: '[Knowledge Hub] Open',
    OPEN_ITEM: '[Knowledge Hub] Open item',
    SELECT_ORGANIZATION: '[Knowledge Hub] Select organization',
    SEARCHING: '[Knowledge Hub] Searching',
    NOT_FOUND: '[Knowledge Hub] Not found',
    RESULTS_LISTED: '[Knowledge Hub] Results listed',
    IMPORT: '[Knowledge Hub] Import',
    IMPORT_DISMISS: '[Knowledge Hub] Import dismiss',
    IMPORT_EDIT_CONTENT: '[Knowledge Hub] Import with content edited',
    PUBLISH: '[Knowledge Hub] Publish',
    PUBLISH_TO: '[Knowledge Hub] Publish to',
    SHARE_ITEM: '[Knowledge Hub] Share item',
    UNSHARE_ITEM: '[Knowledge Hub] Unshare item',
    SHARE_CATEGORY: '[Knowledge Hub] Share category',
    UNSHARE_CATEGORY: '[Knowledge Hub] Unshare category',
  },
  QUICK_LINKS: {
    OPEN: '[Quick Links] Open',
  },
  HOME_PAGE: {
    BANNER_CLICK: '[home page] banner click',
  },
  WORKSPACE: {
    RESTRICT: '[Workspace] Restrict',
    ADD_USERS: '[Workspace] Add users',
    REMOVE_USER: '[Workspace] Remove user',
    OPEN_USER_DETAILS: '[Workspace] Open user details',
    OPEN_RESTRICTED_PAGE: '[Workspace] Open restricted page',
    SEND_ACCESS_REQUEST: '[Workspace] Send access request',
    SWITCH: '[Workspace] Switch',
  },
  ORGANIZATION: {
    SWITCH: '[Organization] Switch',
  },
  COMMUNICATION_CENTER: {
    // Receiver
    NOTIFICATION_SCREEN_OPEN: '[Communication Center] Notification screen open (mobile)',
    NOTIFICATION_OPEN: '[Communication Center] Notification open',
    NOTIFICATION_CLICKED: '[Communication Center] Notification clicked',
    NOTIFICATION_COPIED: '[Communication Center] Notification copied',
    CLICK_ON_REPLY: '[Communication Center] Click on reply',
    ATTACHMENT_OPEN: '[Communication Center] Attachment open',
    MESSAGE_SENT: '[Communication Center] Message sent',
  },
  QUALITY_METRICS: {
    OPEN: '[Quality Metrics] Page view',
    OPEN_RESOURCE: '[Quality Metrics] Open resource',
    WIDGETS_IMPRESSION: '[Quality Metrics] Widgets impression',
    TAB_CLICK: '[Quality Metrics] Tab click',
    CASE_FILTER_CLICK: '[Quality Metrics] Case filter click',
    CASE_OPEN: '[Quality Metrics] Case open',
    CASE_TAB_CLICK: '[Quality Metrics] Case tab click',
    EXTERNAL_LINK_CLICK: '[Quality Metrics] External link click',
    COPY: '[Quality Metrics] Copy',
  },
  SCHEDULE: {
    ENTRY_PAGE_VIEW: '[Schedule] Entry Page view',
    PAGE_VIEW: '[Schedule] Page view',
    UPLOAD_SHIFTS_PAGE_VIEW: '[Schedule] Upload shifts page view',
    WIDGET_IMPRESSION: '[Schedule] Widgets impression',
    OPEN_EVENT: '[Schedule] Open event',
    EDIT_ATTENDEES_OPEN: '[Schedule] Edit attendees open',
    EDIT_ATTENDEES_SUBMIT: '[Schedule] Edit attendees submit',
    UNASSIGN_CLICK: '[Schedule] Unassign click',
    ADD_EVENT_CLICK: '[Schedule] Add event click',
    ADD_EVENT_SUBMIT: '[Schedule] Add event submit',
    FILTER: '[Schedule] Filter',
    START_CHECK_IN: '[Schedule] Start check in',
    CLOSE_CHECK_IN: '[Schedule] Close check in',
    MANUAL_CHECK_IN_OPEN: '[Schedule] manual check in open',
    MANUAL_CHECK_IN_SUBMIT: '[Schedule] manual check in submit',
    SCAN_CHECK_IN: '[Schedule] Scan check in',
    SCAN_AGAIN: '[Schedule] Scan again',
    SHOW_QR: '[Schedule] Show qr',
    QR_NEW_TAB: '[Schedule] Show qr in new tab',
    CHECK_IN_SUBMIT: '[Schedule] check in submit',
    SELF_CHECK_IN: '[Schedule] Self check in',
    RESOURCE_ADD: '[Schedule] Resource add',
    RESOURCE_REMOVE: '[Schedule] Resource remove',
    REPORT_EXPORTED: '[Schedule] Report export',
    PROVIDER_REPORT_OPEN: '[Schedule] Provider report open',
    EVENT_REPORT_OPEN: '[Schedule] Event report open',
    EDIT_EVENT_CLICK: '[Schedule] Edit event click',
    EDIT_EVENT_SUBMIT: '[Schedule] Edit event submit',
    DELETE_EVENT_CLICK: '[Schedule] Delete event click',
    DELETE_EVENT_SUBMIT: '[Schedule] Delete event submit',
  },
  WIDGETS: {
    SEARCH_REDIRECT: {
      CLICK: '[Search Redirect Widget] Click',
    },
    CONTENT_SHORTCUTS: {
      CLICK: '[Content Shortcuts Widget] Click',
    },
    QGENDA_SCHEDULING: {
      IMPRESSION: '[Qgenda Scheduling] Widget Impression',
      CLICK: '[Qgenda Scheduling] Click',
    },
    CALENDAR: {
      IMPRESSION: '[Calendar] Widget Impression',
    },
  },
  MY_CONTENT: {
    PAGE_VIEW: '[My Content] Page view',
    ITEMS_IMPRESSION: '[My Content] Items impression',
    CLICK_ITEM: '[My Content] Click item',
    CLICK_OWNER: '[My Content] Click owner',
    CLICK_PATH: '[My Content] Click path',
    VIEW_MODAL_IMPRESSION: '[My Content] View modal impression',
    CSV_DOWNLOAD: '[My Content] CSV download',
    SHARE_TO_NETWORK: '[My Content] Share to network',
    TRANSFER_ITEM: '[My Content] Transfer item',
    DELETE_ITEM: '[My Content] Delete item',
    CHANGE_OWNER: '[My Content] Change owner',
    EXTEND_EXPIRATION: '[My Content] Extend expiration',
  },
};

export const ANALYTICS_CATEGORIES_TYPES = {
  SECTION: 'section',
  BINDER: 'binder',
  DIRECTORY: 'directory',
};

export const ANALYTICS_CONTENT_CATEGORIES_TYPES = {
  KNOWLEDGE: 'knowledge',
  LAB: 'lab',
  CHECKLIST: 'checklist',
};

export const ANALYTICS_TO_TRACK_VIA_API = [
  EVENTS.APPLICATION.OPEN,
  EVENTS.AUTH.LOGIN,
  EVENTS.AUTH.MAGIC_LINK_TRIGGERED,
  EVENTS.KNOWLEDGE_COMMENTS.COMMENT_SENT,
  EVENTS.KNOWLEDGE_ITEMS.OPEN,
  EVENTS.CONTENT.OPEN,
  EVENTS.SEARCH.SESSION_START,
  EVENTS.CONTACT.OPEN_DETAILS,
  EVENTS.CHECKLISTS.OPEN,
  EVENTS.CHECKLISTS.SIGN_AND_SEND,
  EVENTS.CHECKLISTS.CREATE_REPORT,
];

export const EVENTS_BY_ACTIONS_MAP = {
  [AUTH_FINISH_ONBOARDING]: EVENTS.ONBOARDING.FINISH,
  [AUTH_LOGOUT]: EVENTS.AUTH.LOGOUT,
  [AUTH_LOGIN]: EVENTS.AUTH.LOGIN,
  [FIRST_TIME]: EVENTS.APPLICATION.FIRST_INIT,
  [APP_IS_READY]: EVENTS.APPLICATION.OPEN,
};

export const SESSION_PROPERTIES = {
  CLIENT_APP: 'client app',
  SESSION_ID: 'session id',
  IS_FIRST_TIME: 'first session',
  USER_TYPE: 'user type',
  APP_HASH: 'app hash',
  IS_UPDATE_AVAILABLE: 'is update available',
  DEVICE_ID: 'c8 device id',
  BIOMETRICS_AVAILABLE: 'biometricsAvailable',
};

export const MIXPANEL_TOKENS = {
  [ENVIRONMENT_KEYS.PRODUCTION]: 'a03aba374445d95b9fa4ec14bd701629',
  [ENVIRONMENT_KEYS.STAGING]: '49966fd547743a765f002cdfc9b4df8e',
  [ENVIRONMENT_KEYS.DEVELOPMENT]: '49966fd547743a765f002cdfc9b4df8e',
};

export const COMMUNICATION_CENTER_NAVIGATION_SOURCE = {
  DASHBOARD_WIDGET: 'dashboard widget',
  NOTIFICATION_SCREEN: 'notification screen',
};

export const QUALITY_METRICS_NAVIGATION_SOURCE = {
  QUALITY_METRIC_WIDGET: 'quality metric widget',
  NOTIFICATION_WIDGET: 'notification widget',
  PUSH_NOTIFICATION: 'push notification',
  QUALITY_METRICS_PAGE: 'quality metrics page',
};

export const SESSION_TIMEOUT = 30 * 60 * 1000; // 30 minutes

export const ANALYTICS_STORAGE_KEYS = {
  SESSION_ID: 'analytics_session_id',
  LAST_ACTIVITY: 'analytics_last_activity',
  ACTIVITY_BROADCAST: 'analytics_activity_broadcast',
  DEVICE_ID: 'analytics_device_id',
};

export const ANALYTICS_SOURCES = {
  MY_CONTENT: 'my-content',
  KNOWLEDGE_VIEWER: 'knowledge-viewer',
  SEARCH: 'search',
  KNOWLEDGE_HUB: 'knowledge-hub',
  DASHBOARD: 'dashboard',
  DASHBOARD_QUICK_LINKS: 'dashboard-quick-links',
  DASHBOARD_RECENTLY_UPDATED: 'dashboard-recently-updated-items',
  DASHBOARD_ITEMS_UP_FOR_REVIEW: 'dashboard-items-up-for-review',
  DASHBOARD_MOST_VIEWED_ITEMS: 'dashboard-most-viewed-items',
  DASHBOARD_RECENTLY_ADDED: 'dashboard-recently-added-items',
  DASHBOARD_MOST_VIEWED_BY_ME: 'dashboard-most-viewed-items-by-me',
  ROTATIONS: 'rotations',
  LAB: 'lab',
  CHECKLISTS: 'checklists',
  CONTACTS: 'contacts',
  QUALITY_METRICS: 'quality-metrics',
  SCHEDULE_EVENT_DETAILS: 'schedule-event-details',
  EDUCATIONAL_EVENTS_REPORT: 'educational-events-report',
  SCHEDULE_PAGE_VIEW_TAB: 'schedule-page-view-tab',
  SCHEDULE_PAGE_ASSIGNMENTS_TAB: 'schedule-page-assignments-tab',
  EDIT_ATTENDEES_SCREEN: 'edit attendees screen',
  TRASH_CAN_BUTTON: 'trash can button',
  FAVORITES: 'favorites',
  AI_CHAT: 'ai-chat',
  COMMUNICATION_CENTER: 'communication-center',
};

export const SEARCH_CONTACT_RESULT_TYPES = {
  CALL: 'contact call',
  SMS: 'contact SMS',
  EMAIL: 'contact email',
  PAGER: 'contact pager',
};
